import { IComponentOptions } from 'angular';
import { NewSdcGridCtrl } from './new-sdc-grid.controller';

export const newSdcGridComponent: IComponentOptions = {
  bindings: {
    initialGridState: '<',
    channel: '<',
    currentSchool: '<',
    currentUser: '<',
  },
  controller: NewSdcGridCtrl,
  template: require('./new-sdc-grid.html'),
};
